export const PrintHeader = ({ neg, titolo, overline, children }) => (
  <div className="flex items-start justify-between gap-6 border-b-4 border-orange-600 pb-4" data-testid="print-header">
    <div className="flex items-start gap-4">
      {neg.logo && <img src={neg.logo} alt="Logo" className="max-h-20 max-w-[140px] object-contain" data-testid="print-header-logo" />}
      <div>
        {overline && <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">{overline}</p>}
        <p className="font-heading text-xl font-extrabold" data-testid="print-header-nome">{neg.nome_negozio || "[Nome negozio]"}</p>
        <p className="text-slate-600">{neg.indirizzo}</p>
        <p className="text-slate-600">{[neg.telefono, neg.email].filter(Boolean).join(" · ")}</p>
        {neg.partita_iva && <p className="text-slate-600">P.IVA {neg.partita_iva}</p>}
        {neg.intestazione_extra && <p className="whitespace-pre-wrap text-slate-600" data-testid="print-header-extra">{neg.intestazione_extra}</p>}
      </div>
    </div>
    <div className="max-w-[55%] text-right">
      <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500" data-testid="print-header-titolo">{titolo}</p>
      {children}
    </div>
  </div>
);

export const PrintFooter = ({ text, testId }) => (text
  ? <p className="mt-8 whitespace-pre-wrap border-t border-slate-200 pt-2 text-center text-[10px] text-slate-500" data-testid={testId}>{text}</p>
  : null);
